import React from 'react';

import { StyledButtonWrapper } from '@/shared/components/ui/button/button-wrapper/button-wrapper.styled';
import { TButtonWrapper } from '@/shared/components/ui/button/button-wrapper/button-wrapper.types';

export const ButtonWrapper: React.FC<TButtonWrapper> = ({
  clicked: _,
  ...props
}) => <StyledButtonWrapper {...props} />;
